module.exports = __webpack_public_path__ + "static/media/soTellUs.61260983.png";